import { props } from "./euglena";

(window as any).euglena = props.euglena;

